<template>
  <v-app>
    <v-content>
      <Header/>
      <router-view/>
      <Rodape />
      <BtnWhatsapp />
    </v-content>
  </v-app>
</template>

<script>
import Header from './components/Header';
import Rodape from './components/Rodape';
import BtnWhatsapp from '@/views/BtnWhatsapp';

export default {
  name: 'App',
  components: {
    Header,
    Rodape,
    BtnWhatsapp,
  },
};
</script>

<style>

</style>
